import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import AddBlogLayer from "../../components/AddBlogLayer";
import MasterLayout from "../../masterLayout/MasterLayout";
import AddBlog from "../../components/AddBlog/AddBlog";
const CreateBlogPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Add New Blog' />

                <AddBlog />
            </MasterLayout>
        </>
    );
};

export default CreateBlogPage;
